const BUNDLE_APP = 'app';
const BUNDLE_MODAL = 'modal';
const BUNDLE_RECENT_POSTS_WIDGET_DESKTOP = 'recent-posts-widget-desktop';
const BUNDLE_RECENT_POSTS_WIDGET_MOBILE = 'recent-posts-widget-mobile';
const BUNDLE_CUSTOM_FEED_WIDGET = 'custom-feed-widget';
const BUNDLE_MEMBER_COMMENTS_PAGE = 'member-comments-page';
const BUNDLE_MEMBER_DRAFTS_PAGE = 'member-drafts-page';
const BUNDLE_MEMBER_LIKES_PAGE = 'member-likes-page';
const BUNDLE_MEMBER_POSTS_PAGE = 'member-posts-page';

const CHUNK_COMMON_MEMBER_PAGES = 'common-member-pages';
const CHUNK_VENDOR_MEMBER_PAGES = 'vendor-member-pages';

module.exports = {
  BUNDLE_APP,
  BUNDLE_MODAL,
  BUNDLE_RECENT_POSTS_WIDGET_DESKTOP,
  BUNDLE_RECENT_POSTS_WIDGET_MOBILE,
  BUNDLE_CUSTOM_FEED_WIDGET,
  BUNDLE_MEMBER_COMMENTS_PAGE,
  BUNDLE_MEMBER_DRAFTS_PAGE,
  BUNDLE_MEMBER_LIKES_PAGE,
  BUNDLE_MEMBER_POSTS_PAGE,

  CHUNK_COMMON_MEMBER_PAGES,
  CHUNK_VENDOR_MEMBER_PAGES,
};
